import store from '../../../store';
import { updateApplicationState } from '../home-slice';

import { getIsDemoFeedbackSubmitted } from '../../../shared/utils';

export const handleDemoFeedbackModal = () => {
  const isDemoAccount = store?.getState()?.home?.isDemoAccount;

  if (!window.demoFeedbackTimeout) {
    window.demoFeedbackTimeout = true;
    setTimeout(() => {
      const isDemoFeedbackSubmitted = getIsDemoFeedbackSubmitted() === 'true';
      if (isDemoAccount && !isDemoFeedbackSubmitted) {
        store.dispatch(updateApplicationState({ showDemoFeedbackModal: true }));
      }
    }, 60000);
  }
};
